import { useSelector } from "react-redux";

function useLocale() {
  return useSelector(state => state.locale.language);
}

export default useLocale;
